export default __webpack_public_path__ + "static/media/person-icon.c64f2863.png";